// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__VXY2z","menu-title":"Menu_menu-title__yrx1F","label":"Menu_label__UNF+Q"};